// Shared Apollo Client links and utilities
// This file contains common configurations used by all clients
import { ErrorLink } from '@apollo/client/link/error'
import { notify } from '@/utils/notify'
import { setContext } from '@apollo/client/link/context'
import store from '@/store'
import { ensureFreshToken } from '@/utils/sessionManager'

// Auth Link - Add authentication headers.
// setContext accepts an async resolver, so we refresh the access token on demand
// (single-flight, no-op when still fresh) before reading it — same as the axios
// service interceptors — so GraphQL calls never send a stale/expired token.
export const authLink = setContext(async (_, { headers }) => {
  await ensureFreshToken();
  const token = store.state.login.token;
  return {
    headers: {
      ...headers,
      Authorization: token ? `Bearer ${token}` : ""
    }
  }
})

// Error Link - Handle GraphQL errors
export const errorLink = new ErrorLink(({ graphQLErrors, networkError, operation }) => {
  const { response } = operation.getContext()
  if (response && response.status === 401) {
    notify({
      title: 'Authentication Error',
      message: 'Your session has expired. Please login again.',
      type: 'error',
      duration: 8000,
    })
    return
  }

  // Skip remaining error notifications if _silent flag is set in query context
  if (operation.getContext()._silent) return;

  if (
    networkError &&
    networkError.statusCode !== 401 &&
    !graphQLErrors
  ) {
    notify({
      title: 'Network Error',
      type: 'error',
      message: networkError,
      duration: 8000,
    })
  } else if (graphQLErrors) {
    graphQLErrors.forEach(i => {
      if (!(i.extensions && i.extensions.sub_error_type === 'Z_InputError')) {
        if (
          i.extensions &&
          i.extensions.sub_error_type === 'Z_NotificationError'
        ) {
          notify({
            title: i.title,
            type: 'error',
            message: i.message,
            duration: 8000,
          })
        } else {
          notify({
            title: 'Unexpected Error',
            type: 'error',
            message: i.message,
            duration: 8000,
          })
        }
      }
    })
  }
}) 